// extracted by mini-css-extract-plugin
module.exports = {"tabs":"tabs___LVk61","tabs_item":"tabs_item___18chr","active":"active___XRcw2"};